module.exports = __webpack_public_path__ + "static/img/all_checked.8e9d5887.svg";